import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Navigate, Link } from "react-router-dom";
import MainWrapper from "../../MainWrapper";
import { Table } from "react-bootstrap";
import Icon from "react-icons-kit";
import { ic_arrow_back } from "react-icons-kit/md";
import Loader from "../../layouts/Loader";
import axios from "axios";
import { API_URL } from "../../../config";

// Drill-down list opened from the "Estimate Ready" widget: floorplans Estimating
// marked ready that Sales hasn't started an order for. Respects the role's dataScope
// ("self" => only the logged-in salesperson's floorplans).
const EstimateReady = ({
  auth: { auth, isAuthenticated },
  Admin: { userMenuList },
}) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = auth && auth[0] ? auth[0].token : null;
  const userId = auth && auth[0] ? auth[0].userId : null;
  const salesPersonId = auth && auth[0] ? auth[0]?.salesPersonId : null;
  let tmpUserId = userId;
  if(salesPersonId){
    tmpUserId = salesPersonId
  }
  const dashboard =
    userMenuList && userMenuList[0] ? userMenuList[0].dashboard : null;
  const dataScope = (dashboard && dashboard.dataScope) || "all";
  const scopedSalesPersonId = dataScope === "self" ? tmpUserId : null;

  useEffect(() => {
    if (!token) return;
    setLoading(true);
    const params = {};
    if (scopedSalesPersonId) params.salesPersonId = scopedSalesPersonId;
    axios
      .get(`${API_URL}/Dashboard/api/Dashboard/EstimateReady`, {
        headers: { Authorization: `Bearer ${token}` },
        params,
      })
      .then((res) => {
        const data = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.result) || [];
        setRows(data);
      })
      .catch((err) => {
        console.warn("Could not load Estimate Ready list:", err.message);
      })
      .finally(() => setLoading(false));
  }, [token, scopedSalesPersonId]);

  if (!isAuthenticated) return <Navigate to="/login" />;

  const formatDate = (value) => {
    if (!value) return "—";
    const d = new Date(value);
    if (isNaN(d.getTime())) return "—";
    const month = d.getMonth() + 1;
    const day = d.getDate();
    const year = d.getFullYear();
    return `${month < 10 ? "0" + month : month}-${day < 10 ? "0" + day : day}-${year}`;
  };

  return (
    <Fragment>
      <MainWrapper>
        <Loader loading={loading}>
          <div className="container">
            <div className="sub-header mt-5 mb-3">
              <h2>Estimate Ready</h2>
              <Link className="btn btn-primary me-1" to="/dashboard">
                <Icon icon={ic_arrow_back} />Back
              </Link>
            </div>
            <Table bordered hover responsive>
              <thead>
                <tr>
                  <th>Date Ready</th>
                  <th>Property Name</th>
                  <th>Floorplan Name</th>
                  <th>Store Name</th>
                  <th>Salesperson</th>
                </tr>
              </thead>
              <tbody>
                {rows.length > 0 ? (
                  rows.map((r, i) => (
                    <tr key={i}>
                      <td>{formatDate(r.dateReady)}</td>
                      <td>{r.propertyName || "—"}</td>
                      <td>{r.floorplanName || "—"}</td>
                      <td>{r.storeName || "—"}</td>
                      <td>{r.salesPersonName || "—"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={5} className="text-center">
                      No floorplans waiting for selection.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </Loader>
      </MainWrapper>
    </Fragment>
  );
};

const mapStateToProps = ({ auth, Admin }) => ({ auth, Admin });

export default connect(mapStateToProps)(EstimateReady);